"use strict";

exports.onRouteUpdate = function (_ref) {
  var _ref$location = _ref.location,
      location = _ref$location === undefined ? {} : _ref$location;

  // Don't track while developing.
  if (process.env.NODE_ENV === "production" && typeof _hmt === "function") {
    window._hmt.push(["_trackPageview", "" + location.pathname + location.search + location.hash]);
  }
};